import { Box, Button, Drawer, TextField, Typography } from '@material-ui/core';
import { useState } from 'react';
import useNoteContext from '../../hooks/useNoteContext/useNoteContext';
import useVideoContext from '../../hooks/useVideoContext/useVideoContext';
import NoteIcon from '../../icons/NoteIcon';
import Snackbar from '../Snackbar/Snackbar';

export default function NoteDrawer() {
  const { noteDrawerOpen, setNoteDrawerOpen, message, setMessage } = useNoteContext();
  const { room } = useVideoContext();
  const [notifOpen, setNotifOpen] = useState(false);
  const [loading, setLoading] = useState(false);

  const submitNote = async () => {
    const endpoint = `${process.env.REACT_APP_TOKEN_ENDPOINT}/work-orders/call/note?room=${room?.name}`;

    setLoading(true);

    const res = await fetch(endpoint, {
      method: 'PUT',
      headers: {
        'content-type': 'application/json',
        accept: 'application/json',
        Authorization: 'Bearer ' + localStorage.getItem('portal_token'),
      },
      body: JSON.stringify({ note: message }),
    });

    setLoading(false);

    if (res.status === 200) {
      setNotifOpen(true);
      setTimeout(() => setNotifOpen(false), 4000);
    }
  };

  return (
    <>
      <Snackbar
        open={notifOpen}
        headline="Note saved successfully"
        message=""
        variant="info"
        handleClose={() => setNotifOpen(false)}
      />
      <Drawer open={noteDrawerOpen} anchor="right" onClose={() => setNoteDrawerOpen(false)}>
        <Box width={450} maxWidth="90vw">
          <Box py={4} px={2}>
            <Box display="flex" alignItems="center" gridGap={12}>
              <NoteIcon />
              <Typography variant="h6">Añadir nota</Typography>
            </Box>

            <Box mt={4}>
              <TextField
                fullWidth
                label="Nota"
                multiline
                rows={10}
                variant="outlined"
                value={message}
                onChange={e => setMessage(e.target.value)}
              />
            </Box>

            <Box mt={2}>
              <Button fullWidth variant="contained" color="primary" onClick={() => submitNote()} disabled={loading}>
                Guardar
              </Button>
            </Box>
          </Box>
        </Box>
      </Drawer>
    </>
  );
}
